<template>
  <b-card>
    <b-row>
      <b-col>
        <h4 class="float-left">Deal Catalog</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert v-if="this.errorMessage" variant="danger" class="float-left" show dismissible>{{ this.errorMessage }}
        </b-alert>
      </b-col>
    </b-row>
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <b-row class="my-4">
      <b-col cols="3">
        <b-row class="mt-3">
          <b-col class="text-left">
            <b-form-group label="Filter" class="font-weight-bold">
              <b-input-group>
                <b-form-input type="text" v-model="filter" placeholder="Type to Search" size="sm"/>
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="7">
      </b-col>
      <b-col cols="2">
        <cusip-search
          @showSpinner="showSpinner = true"
          @hideSpinner="showSpinner = false"
          @error="inputErrorMsg = $event"/>
      </b-col>
    </b-row>
    <b-card no-body class="mb-1">
      <div v-for="(type, index) in this.types" :key=index>
        <div v-if="filteredDeals[type.name] ? filteredDeals[type.name].length != 0 : false">
          <b-card-header header-tag="header" class="p-0 mt-1">
            <b-btn block href="#" v-b-toggle="`collapse${index}`" variant="info" class="text-left">{{ type.name }}
            </b-btn>
          </b-card-header>
          <b-card-body>
            <b-collapse :id="`collapse${index}`">
              <deal-list :path="path || type.path" :deals="filteredDeals[type.name] || []" :isModal="isModal"
                         :allDataAvailable="allDataAvailable"/>
            </b-collapse>
            <b-row v-if="index == (Object.keys(filteredDeals).length - 1)">
              <b-btn size="sm" variant="link" v-if="isAdmin" @click="exportDealsList()">Export</b-btn>
            </b-row>
          </b-card-body>
        </div>
      </div>
    </b-card>
  </b-card>
</template>

<script>
import service                                                from '../../services/HttpRequestService';
import formatter                                              from '../../utilities/Formatter';
import DealList                                               from './DealList';
import CusipSearch                                            from './CusipSearch';
import { typesNames, filterTypes, initDealList, filterDeals } from '../../utilities/DealTypes';
import { TRACE_ERROR }                                        from '../../constants';
import FileSaver                                              from 'file-saver';
import ObjAlertState                                          from '@/components/common/alert/ObjAlertState';
import moment                                                 from 'moment';
import UtilsData                                              from '@/utilities/UtilsData';
import { mapGetters }                                         from 'vuex';

export default {
  props: {
    path: String,
    shownTypes: {
      type: Array,
      default: function () {
        return typesNames;
      }
    },
    isModal: Boolean
  },
  data() {
    return {
      types: filterTypes(this.shownTypes),
      deals: initDealList(this.shownTypes),
      fields: [
        'DealName',
        'IssueDate',
        'MaturityDate',
        'OriginalBalance',
        'CurrentBalance',
        'DealFactor',
        'FactorDate'
      ],
      filter: '',
      showSpinner: false,
      allDataAvailable: false
    };
  },
  async created() {
    try {
      /*
            let dealNames = await service.get('deals/userDealsNames');
            let dealsFromDealName = dealNames.data.map(name => {
              return { DealName: name };
            });
            this.prepareDeals(dealsFromDealName);
            this.showSpinner = false;
      */

      this.showSpinner            = true;
      let dealsWithAdditionalData = await service.getUserDeals();
      this.allDataAvailable       = true;
      this.showSpinner            = false;
      this.prepareDeals(dealsWithAdditionalData.data);
    } catch (err) {
      let res = err.response;
      await service.log(TRACE_ERROR, res.data.Message, err.stack);
      this.$router.push({
        path: 'error',
        query: { status: res.status, reason: res.statusText, msg: res.data }
      });
    } finally {
      this.showSpinner = false;
    }
  },
  methods: {
    async exportDealsList() {
      const response = await service.getUserDeals(true);
      if (!response || !response.data) {
        return;
      }
      FileSaver.saveAs(new Blob([response.data]), 'deals_catalog.csv');
    },
    prepareDeals(dealsInput) {
      if (dealsInput.length > 0) {
        let deals = formatter.formatDataInArray(
          dealsInput,
          ['OriginalBalance', 'CurrentBalance'],
          ['IssueDate', 'MaturityDate'],
          [],
          ['DealFactor']
        );
        deals     = formatter.formatDatesInArray(dealsInput, ['FactorDate'], 'MM/YYYY');
        this.$store.commit('setDealName', this.$store.getters.dealName || deals[0].DealName);
        this.types.forEach(type => {
          this.deals[type.name] = filterDeals(deals, type.filter);
        });
        this.$forceUpdate();
      }
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin'
    ]),
    filteredDeals() {
      let ret = {};

      Object.keys(this.deals).forEach(key => {
        const deals = this.deals[key];
        ret[key]    = filterDeals(deals, this.filter);
      });

      return ret;
    },
    errorMessage() {
      return this.$route.query.error;
    }
  },
  components: {
    DealList,
    CusipSearch
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
}
</style>
